// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.guia {
    border-radius: 5px;
    padding: 5px;
}
.guia:hover {
    background-color: rgba(0, 0, 0, 0.05);
    cursor: pointer;
}
.guia-selected {
    background-color: rgba(0, 0, 0, 0.1);
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/trainer-dashboard/programas/config-avanzada/guias/guias.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,qCAAqC;IACrC,eAAe;AACnB;AACA;IACI,oCAAoC;IACpC,eAAe;AACnB","sourcesContent":[".guia {\n    border-radius: 5px;\n    padding: 5px;\n}\n.guia:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n    cursor: pointer;\n}\n.guia-selected {\n    background-color: rgba(0, 0, 0, 0.1);\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
